import React from 'react';
import PropTypes from 'prop-types';
import { Day } from './Day';
import { DateUtils } from '../../utils/DateUtils';

export const Week = (props) => {
    let date = props.start;

    const days = [];
    for (let i = 0; i < 7; i++) {
        days.push(<Day key={date} date={date} />);
        date = DateUtils.add(date, 1);
    }

    return (
        <div className="odf-calendar-row">
            {days}
        </div>
    );
};

Week.propTypes = {
    start: PropTypes.instanceOf(Date).isRequired,
};
